// Gedeelde helpers voor bord-items (BTW + subsidie samen), zie AGENTS.md 3.29.

export const TYPE_BADGE = {
  btwBatterij: { label: "BTW", cls: "bg-teal-50 text-teal-800 ring-teal-200" },
  eia: { label: "EIA", cls: "bg-indigo-50 text-indigo-800 ring-indigo-200" },
  eiaZon: { label: "EIA Zon", cls: "bg-amber-50 text-amber-800 ring-amber-200" },
  isde: { label: "ISDE", cls: "bg-fuchsia-50 text-fuchsia-800 ring-fuchsia-200" },
};

export const typeBadge = (module) => TYPE_BADGE[module] ?? { label: module, cls: "bg-gray-100 text-gray-700 ring-gray-200" };

export const TYPE_FILTER_OPTIONS = [
  { value: "", label: "Alles" },
  { value: "btw", label: "BTW Batterij" },
  { value: "eia", label: "EIA" },
  { value: "eiaZon", label: "EIA Zon" },
  { value: "isde", label: "ISDE" },
];

export const PARTNER_LINE_BADGE = {
  pending: { label: "Te factureren", cls: "bg-violet-50 text-violet-800 ring-violet-200" },
  invoiced: { label: "Gefactureerd", cls: "bg-sky-50 text-sky-800 ring-sky-200" },
  paid: { label: "Partner betaald", cls: "bg-emerald-50 text-emerald-800 ring-emerald-200" },
  credited: { label: "Gecrediteerd", cls: "bg-rose-50 text-rose-800 ring-rose-200" },
};

export const SUBSIDIE_STATUS_LABEL = {
  "In-behandeling": "In behandeling",
  "Ingediend-bij-rvo": "Ingediend bij RVO",
  Goedgekeurd: "Goedgekeurd",
  Afgekeurd: "Afgekeurd",
};

// Welke subsidie-statuswijzigingen de server toestaat (adminUpdateStatus):
// vanuit In-behandeling of Ingediend naar Goedgekeurd, Afgekeurd of Ingediend.
export const subsidieTransitionAllowed = (from, to) => {
  if (!to || from === to) return false;
  if (from === "Goedgekeurd" || from === "Afgekeurd") return false;
  return ["Goedgekeurd", "Afgekeurd", "Ingediend-bij-rvo"].includes(to);
};

export const formatEuro = (n) =>
  n == null ? "" : `€ ${Number(n).toLocaleString("nl-NL", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const formatShortDate = (d) => {
  if (!d) return "";
  const dt = new Date(d);
  if (Number.isNaN(dt.getTime())) return "";
  return dt.toLocaleDateString("nl-NL", { day: "numeric", month: "short" });
};

export const deadlineTone = (deadlineAt) => {
  if (!deadlineAt) return null;
  const diff = (new Date(deadlineAt).getTime() - Date.now()) / 86400000;
  if (diff < 0) return { cls: "bg-rose-50 text-rose-700 ring-rose-200", label: "Verlopen" };
  if (diff <= 7) return { cls: "bg-amber-50 text-amber-800 ring-amber-200", label: "Deze week" };
  return { cls: "bg-gray-50 text-gray-600 ring-gray-200", label: "" };
};
